import * as React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { CheckinOrderFragment } from '@websky/graphql';
import { UnconfirmedServicesMap } from '../types';
import { useTheme } from '../../../../../../../theme';
import { REMOVABLE_STATUSES } from '../utils';
import { getTravellerName } from '../../../../../../../utils';

interface Props {
	order: CheckinOrderFragment;
	unconfirmedServices: UnconfirmedServicesMap;
}

const Services: React.FC<Props> = ({ order, unconfirmedServices }) => {
	const { t } = useTranslation('Checkin');
	const theme = useTheme('Checkin').UnconfirmedServicesModal;

	const getPassengerName = (passengerId: string) => {
		return getTravellerName(order.travellers.find(traveller => traveller.id === passengerId));
	};

	const getSegmentIataCodes = (segmentId: string) => {
		const segment = order.segments.find(segment => segment.id === segmentId);

		const departure = segment?.departure?.airport?.iata;
		const arrival = segment?.arrival?.airport?.iata;

		return `${departure} — ${arrival}`;
	};

	return (
		<>
			{Array.from(unconfirmedServices.entries()).map(([status, services]) => (
				<div
					key={status}
					className={cn(theme.services, { [theme.status_accent]: REMOVABLE_STATUSES.includes(status) })}
				>
					<div className={theme.status}>{t(`${status} services`)}</div>

					{Array.from(services.entries()).map(([passengerId, segmentServices]) => (
						<div key={passengerId} className={theme.passenger}>
							<div className={theme.passenger__name}>{getPassengerName(passengerId)}:</div>

							<div className={theme.passenger__segment}>
								{Array.from(segmentServices.entries()).map(([segmentId, segmentServices]) => {
									const services = segmentServices
										.map(service =>
											service.count ? `${service.count}x ${service.name}` : service.name
										)
										.join(', ');

									return (
										<div key={segmentId}>
											{getSegmentIataCodes(segmentId)}, {services}
										</div>
									);
								})}
							</div>
						</div>
					))}
				</div>
			))}
		</>
	);
};

export default Services;
